/* ============================================================
   Famitextil · tema Shopify
   Cabecera, menú, carrito (API de Shopify), planos a escala, ficha,
   filtros del catálogo, sala navideña, videos y apariciones.
   Sin dependencias. Los datos llegan en window.FAMITEXTIL (snippets/ajustes-js).
   ============================================================ */
(() => {
  "use strict";

  const F = window.FAMITEXTIL || { rutas: {}, textos: {} };
  const T = F.textos || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const raiz = document.documentElement;

  /* ── Utilidades ─────────────────────────────────────────── */
  const pesos = (centavos) =>
    "$ " + Math.round(centavos / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  const clave = (s) =>
    String(s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const plantilla = (txt, datos) => String(txt || "").replace(/\[(\w+)\]/g, (_, k) => (k in datos ? datos[k] : ""));

  /** Tallas de Ajustes del tema: «Sencilla | 100 | 190 | sencillas» */
  const TALLAS = String(F.tallas || "")
    .split(/\r?\n/)
    .map((l) => l.split("|").map((x) => x.trim()))
    .filter((p) => p[0])
    .map((p) => ({ clave: clave(p[0]), nombre: p[0], ancho: Number(p[1]) || 0, largo: Number(p[2]) || 0, boton: p[3] || p[0].toLowerCase() }));
  const tallaDe = (k) => TALLAS.find((t) => t.clave === k) || null;

  /** Bloqueo de scroll compartido por menú, carrito y guía. */
  const bloqueos = new Set();
  const bloquear = (quien, si) => {
    if (si) bloqueos.add(quien);
    else bloqueos.delete(quien);
    raiz.classList.toggle("lock-scroll", bloqueos.size > 0);
  };

  /* ── Apariciones al entrar en pantalla ──────────────────
     Tres redes que no dependen de que el navegador pinte: revelado a mano a los 90 ms de lo que ya
     está en pantalla, repaso al volver a la pestaña y, si el observador no contesta en 2,5 s,
     revelado por scroll. Así la página nunca queda tapada. */
  function apariciones() {
    const nodos = $$("[data-reveal]");
    if (!nodos.length) return;
    if (reduce() || !("IntersectionObserver" in window)) {
      nodos.forEach((n) => n.classList.add("is-in"));
      return;
    }
    let contesto = false;
    const mostrar = (n) => n.classList.add("is-in");
    const io = new IntersectionObserver(
      (entradas) => {
        contesto = true;
        entradas.forEach((e) => {
          if (e.isIntersecting) {
            mostrar(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 },
    );
    nodos.forEach((n) => io.observe(n));
    const repaso = () => {
      const alto = window.innerHeight * 0.92;
      $$("[data-reveal]:not(.is-in)").forEach((n) => {
        const r = n.getBoundingClientRect();
        if (r.top < alto && r.bottom > 0) mostrar(n);
      });
    };
    setTimeout(repaso, 90);
    document.addEventListener("visibilitychange", () => !document.hidden && repaso());
    window.addEventListener("pageshow", repaso);
    setTimeout(() => {
      if (contesto) return;
      let espera = 0;
      const alMover = () => {
        if (espera) return;
        espera = setTimeout(() => {
          espera = 0;
          repaso();
        }, 200);
      };
      window.addEventListener("scroll", alMover, { passive: true });
      window.addEventListener("resize", alMover);
      repaso();
    }, 2500);
  }

  /* ── Cabecera y menú móvil ─────────────────────────────── */
  function cabecera() {
    const header = $("[data-cabecera]");
    if (!header) return;
    const sobreFoto = header.hasAttribute("data-sobre-foto");
    const menu = $("[data-menu-movil]");
    const boton = $("[data-menu-boton]");
    let solido = false;
    let abierto = false;

    const pintar = () => {
      header.dataset.estado = abierto ? "menu" : solido ? "solido" : sobreFoto ? "claro" : "transparente";
    };

    const centinela = $("[data-centinela]");
    if (centinela && "IntersectionObserver" in window) {
      new IntersectionObserver(([e]) => {
        solido = !e.isIntersecting;
        pintar();
      }).observe(centinela);
    }
    // Respaldo por si el observador no contesta (pestaña sin pintar).
    const porScroll = () => {
      const s = window.scrollY > 24;
      if (s !== solido) {
        solido = s;
        pintar();
      }
    };
    window.addEventListener("scroll", porScroll, { passive: true });
    porScroll();

    if (!menu || !boton) return;
    const enlaces = $$("[data-menu-enlace]", menu);
    const alternar = (si) => {
      abierto = si;
      boton.setAttribute("aria-expanded", String(si));
      boton.setAttribute("aria-label", si ? boton.dataset.textoCerrar : boton.dataset.textoAbrir);
      $("[data-icono-abrir]", boton).hidden = si;
      $("[data-icono-cerrar]", boton).hidden = !si;
      menu.toggleAttribute("data-abierto", si);
      menu.setAttribute("aria-hidden", String(!si));
      menu.inert = !si;
      enlaces.forEach((a) => (a.style.opacity = si ? "1" : "0"));
      bloquear("menu", si);
      pintar();
    };
    boton.addEventListener("click", () => alternar(!abierto));
    enlaces.forEach((a) => a.addEventListener("click", () => alternar(false)));
    $$("a", menu).forEach((a) => a.addEventListener("click", () => alternar(false)));
    document.addEventListener("keydown", (e) => e.key === "Escape" && abierto && alternar(false));
    window.matchMedia("(min-width: 1024px)").addEventListener("change", (m) => m.matches && abierto && alternar(false));
  }

  /* ── Carrito ───────────────────────────────────────────── */
  const Carrito = (() => {
    let panel, fondo, ultimoFoco;

    const enlazar = () => {
      panel = $("[data-carrito]");
      fondo = $("[data-carrito-fondo]");
    };

    const abrir = () => {
      if (!panel) return;
      ultimoFoco = document.activeElement;
      panel.toggleAttribute("data-abierto", true);
      fondo.toggleAttribute("data-abierto", true);
      panel.setAttribute("aria-hidden", "false");
      panel.inert = false;
      bloquear("carrito", true);
      requestAnimationFrame(() => $("[data-cerrar-carrito]", panel)?.focus());
    };
    const cerrar = () => {
      if (!panel || !panel.hasAttribute("data-abierto")) return;
      panel.removeAttribute("data-abierto");
      fondo.removeAttribute("data-abierto");
      panel.setAttribute("aria-hidden", "true");
      panel.inert = true;
      bloquear("carrito", false);
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    };

    const contador = (n) => {
      $$("[data-contador]").forEach((c) => {
        c.textContent = n;
        c.hidden = n === 0;
      });
      const palabra = n === 1 ? T.pieza : T.piezas;
      $$("[data-abrir-carrito]").forEach((b) => b.setAttribute("aria-label", plantilla(T.abrirPedido, { cantidad: n, piezas: palabra })));
    };

    const pintar = (html) => {
      if (!html || !panel) return;
      const doc = new DOMParser().parseFromString(html, "text/html");
      ["[data-carrito-titulo]", "[data-carrito-cuerpo]"].forEach((s) => {
        const nuevo = $(s, doc);
        const viejo = $(s, panel);
        if (nuevo && viejo) viejo.replaceWith(nuevo);
      });
    };

    const pedir = async (url, cuerpo) => {
      const r = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ ...cuerpo, sections: "carrito", sections_url: window.location.pathname }),
      });
      const datos = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(datos.description || datos.message || T.errorCarrito);
      return datos;
    };

    const refrescarConteo = async () => {
      try {
        const r = await fetch(F.rutas.carrito + ".js", { headers: { Accept: "application/json" } });
        const c = await r.json();
        contador(c.item_count || 0);
      } catch (e) {}
    };

    const agregar = async (id, cantidad) => {
      const datos = await pedir(F.rutas.agregar, { items: [{ id, quantity: cantidad }] });
      pintar(datos.sections && datos.sections.carrito);
      await refrescarConteo();
      return datos;
    };

    const cambiar = async (key, cantidad) => {
      try {
        const datos = await pedir(F.rutas.cambiar, { id: key, quantity: cantidad });
        pintar(datos.sections && datos.sections.carrito);
        contador(datos.item_count || 0);
      } catch (e) {
        const aviso = $("[data-carrito-error]", panel);
        if (aviso) {
          aviso.textContent = e.message || T.errorCarrito;
          aviso.hidden = false;
        }
      }
    };

    const iniciar = () => {
      enlazar();
      if (!panel) return;
      document.addEventListener("click", (e) => {
        const a = e.target.closest("[data-abrir-carrito]");
        if (a) {
          e.preventDefault();
          abrir();
          return;
        }
        if (e.target.closest("[data-cerrar-carrito]")) {
          const enlace = e.target.closest("a[href]");
          cerrar();
          if (!enlace) e.preventDefault();
          return;
        }
        const b = e.target.closest("[data-cambiar]");
        if (b && panel.contains(b)) {
          b.disabled = true;
          cambiar(b.dataset.cambiar, Number(b.dataset.cantidad));
        }
      });
      fondo.addEventListener("click", cerrar);
      document.addEventListener("keydown", (e) => e.key === "Escape" && cerrar());
      // Volver con «atrás» desde el checkout: el carrito puede haber cambiado.
      window.addEventListener("pageshow", (e) => e.persisted && refrescarConteo());
    };

    return { iniciar, abrir, cerrar, agregar };
  })();

  /* ── Planos a escala ───────────────────────────────────── */
  const SVG = "http://www.w3.org/2000/svg";
  const el = (tag, attrs = {}, padre) => {
    const n = document.createElementNS(SVG, tag);
    for (const [k, v] of Object.entries(attrs)) n.setAttribute(k, v);
    if (padre) padre.appendChild(n);
    return n;
  };
  const TONOS = {
    crema: { trazo: "var(--color-crema)", texto: "var(--color-crema)", suave: "color-mix(in srgb, var(--color-crema) 16%, transparent)" },
    pizarra: { trazo: "var(--color-pizarra)", texto: "var(--color-tinta)", suave: "color-mix(in srgb, var(--color-pizarra) 10%, transparent)" },
  };

  /** Resorte amortiguado (≈ spring de Motion, duración 0,9 s, rebote 0,12). */
  const resorte = (t) => {
    const z = 0.75;
    const w0 = 10;
    const wd = w0 * Math.sqrt(1 - z * z);
    return 1 - Math.exp(-z * w0 * t) * (Math.cos(wd * t) + ((z * w0) / wd) * Math.sin(wd * t));
  };

  /**
   * Plano de la cama a escala real (1 unidad = 1 cm) en un lienzo de 250 cm. Al cambiar la talla,
   * colchón, almohadas y cotas se redibujan con un resorte.
   */
  class PlanoCama {
    constructor(svg) {
      this.svg = svg;
      this.tono = TONOS[svg.dataset.tono] || TONOS.pizarra;
      this.etiqueta = svg.dataset.etiqueta !== "false";
      this.escala = Number(svg.dataset.escalaTexto) || 1;
      const BOX = 250;
      this.BOX = BOX;
      svg.setAttribute("viewBox", `0 0 ${BOX} ${BOX + (this.etiqueta ? 20 : 0)}`);
      svg.setAttribute("fill", "none");
      svg.setAttribute("role", "img");
      svg.style.fontFamily = "var(--font-sans)";
      svg.style.fontVariantNumeric = "tabular-nums";
      svg.innerHTML = "";
      const t = this.tono;
      const st = (n, extra = {}) => {
        n.style.stroke = t.trazo;
        Object.assign(n.style, extra);
        return n;
      };
      this.colchon = st(el("rect", { rx: 4, "stroke-width": 1.1 }, svg), { fill: t.suave });
      this.doblez = st(el("line", { "stroke-width": 0.7, "stroke-dasharray": "3 3", opacity: 0.8 }, svg));
      this.alm1 = st(el("rect", { rx: 5, "stroke-width": 0.9 }, svg), { fill: t.suave });
      this.alm2 = st(el("rect", { rx: 5, "stroke-width": 0.9 }, svg), { fill: t.suave });
      const g1 = el("g", { "stroke-width": 0.8 }, svg);
      g1.style.stroke = t.trazo;
      this.cotaA = [el("line", {}, g1), el("line", {}, g1), el("line", {}, g1)];
      const g2 = el("g", { "stroke-width": 0.8 }, svg);
      g2.style.stroke = t.trazo;
      this.cotaL = [el("line", {}, g2), el("line", {}, g2), el("line", {}, g2)];
      const fs = 10 * this.escala;
      this.fs = fs;
      this.txtA = el("text", { "text-anchor": "middle", "font-size": fs }, svg);
      this.txtL = el("text", { "text-anchor": "middle", "font-size": fs, "writing-mode": "vertical-rl" }, svg);
      this.txtA.style.fill = t.texto;
      this.txtL.style.fill = t.texto;
      if (this.etiqueta) {
        this.nombre = el("text", { x: BOX / 2, y: BOX + 12, "text-anchor": "middle", "font-size": 12 * this.escala }, svg);
        this.nombre.style.fill = t.texto;
        this.nombre.style.fontFamily = "var(--font-display)";
      }
      this.estado = null;
      this.anim = 0;
    }

    medir(w, h) {
      const x = (this.BOX - w) / 2;
      const y = (this.BOX - h) / 2 + 6;
      const dos = w >= 140 ? 1 : 0;
      const pw = dos ? w / 2 - 10 : Math.min(w - 20, 70);
      return { x, y, w, h, pw, dos };
    }

    dibujar(s) {
      const { x, y, w, h, pw, dos } = s;
      const ph = 22;
      const fs = this.fs;
      const a = (n, o) => {
        for (const [k, v] of Object.entries(o)) n.setAttribute(k, v);
      };
      a(this.colchon, { x, y, width: w, height: h });
      a(this.doblez, { x1: x, x2: x + w, y1: y + ph + 22, y2: y + ph + 22 });
      // Con una almohada, la segunda se funde sobre la primera.
      const x1Dos = x + 7;
      const x1Una = x + (w - pw) / 2;
      const x1 = x1Una + (x1Dos - x1Una) * dos;
      const x2 = x1 + (pw + 6) * dos;
      a(this.alm1, { x: x1, y: y + 8, width: pw, height: ph });
      a(this.alm2, { x: x2, y: y + 8, width: pw, height: ph, opacity: dos });
      const yA = y - 16;
      a(this.cotaA[0], { x1: x, x2: x + w, y1: yA, y2: yA });
      a(this.cotaA[1], { x1: x, x2: x, y1: yA - 4, y2: yA + 4 });
      a(this.cotaA[2], { x1: x + w, x2: x + w, y1: yA - 4, y2: yA + 4 });
      a(this.txtA, { x: x + w / 2, y: y - 19 - fs * 0.3 });
      const xL = x + w + 16;
      a(this.cotaL[0], { x1: xL, x2: xL, y1: y, y2: y + h });
      a(this.cotaL[1], { x1: xL - 4, x2: xL + 4, y1: y, y2: y });
      a(this.cotaL[2], { x1: xL - 4, x2: xL + 4, y1: y + h, y2: y + h });
      a(this.txtL, { x: x + w + 22 + fs * 0.35, y: y + h / 2 });
    }

    poner(talla, animar = true) {
      if (!talla || !talla.ancho) return;
      const destino = this.medir(talla.ancho, talla.largo);
      this.txtA.textContent = `${talla.ancho} cm`;
      this.txtL.textContent = `${talla.largo} cm`;
      if (this.nombre) this.nombre.textContent = talla.nombre;
      this.svg.setAttribute("aria-label", plantilla(T.plano, { talla: talla.nombre, ancho: talla.ancho, largo: talla.largo }));
      cancelAnimationFrame(this.anim);
      if (!this.estado || !animar || reduce()) {
        this.estado = destino;
        this.dibujar(destino);
        return;
      }
      const desde = { ...this.estado };
      const t0 = performance.now();
      const paso = (ahora) => {
        const t = Math.min((ahora - t0) / 1000, 0.9);
        const k = t >= 0.9 ? 1 : resorte(t);
        const s = {};
        for (const p of Object.keys(destino)) s[p] = desde[p] + (destino[p] - desde[p]) * k;
        this.estado = s;
        this.dibujar(s);
        if (t < 0.9) this.anim = requestAnimationFrame(paso);
        else {
          this.estado = destino;
          this.dibujar(destino);
        }
      };
      this.anim = requestAnimationFrame(paso);
    }
  }

  const planos = new WeakMap();
  const planoDe = (svg) => {
    if (!planos.has(svg)) planos.set(svg, new PlanoCama(svg));
    return planos.get(svg);
  };
  function planosCama() {
    $$("svg[data-plano-cama]").forEach((svg) => {
      const p = planoDe(svg);
      p.poner(tallaDe(svg.dataset.talla) || tallaDe(clave(svg.dataset.talla)) || TALLAS[2] || TALLAS[0], false);
    });
  }

  /** 135 → «1,35 m»; 200 → «2 m»; 45 → «45 cm» */
  const medida = (cm) => {
    if (cm < 100) return `${cm} cm`;
    const m = cm / 100;
    return `${m.toLocaleString("es-CO", { minimumFractionDigits: Number.isInteger(m) ? 0 : 2 })} m`;
  };

  /** Plano de una pieza sin talla (cortina, mantel, cojín) con sus cotas reales. */
  function planoPieza(svg) {
    let d;
    try {
      d = JSON.parse(svg.dataset.planoPieza);
    } catch (e) {
      return;
    }
    const tipo = d.tipo;
    const [a, b] = [Number(d.ancho), Number(d.largo)];
    if (!a || !b) return;
    const [cw, ch] = tipo === "mantel" ? [Math.max(a, b), Math.min(a, b)] : [a, b];
    const LARGO = 200;
    const PAD = { top: 44, right: 50, bottom: 14, left: 14 };
    const k = LARGO / Math.max(cw, ch);
    const w = cw * k;
    const h = ch * k;
    const x = PAD.left;
    const y = PAD.top;
    const fs = 10 * (Number(svg.dataset.escalaTexto) || 1);
    const t = TONOS.pizarra;
    svg.innerHTML = "";
    svg.setAttribute("viewBox", `0 0 ${w + PAD.left + PAD.right} ${h + PAD.top + PAD.bottom}`);
    svg.setAttribute("fill", "none");
    svg.setAttribute("role", "img");
    svg.setAttribute("aria-label", plantilla(T.planoPieza, { pieza: d.nombre || tipo, ancho: medida(cw), largo: medida(ch) }));
    svg.style.fontFamily = "var(--font-sans)";
    svg.style.fontVariantNumeric = "tabular-nums";
    const st = (n, fill) => {
      n.style.stroke = t.trazo;
      if (fill) n.style.fill = fill;
      return n;
    };
    if (tipo === "cortina") {
      st(el("line", { x1: x - 8, x2: x + w + 8, y1: y - 5, y2: y - 5, "stroke-width": 1.6, "stroke-linecap": "round" }, svg));
      for (let i = 0; i < 8; i++) st(el("circle", { cx: x + (w / 8) * (i + 0.5), cy: y - 5, r: 2.4, "stroke-width": 0.8 }, svg), "var(--color-crema)");
      st(el("rect", { x, y, width: w, height: h, "stroke-width": 1.1 }, svg), t.suave);
      for (let i = 0; i < 7; i++) st(el("line", { x1: x + (w / 8) * (i + 1), x2: x + (w / 8) * (i + 1), y1: y + 3, y2: y + h - 3, "stroke-width": 0.6, "stroke-dasharray": "3 4", opacity: 0.7 }, svg));
    } else if (tipo === "mantel") {
      st(el("rect", { x, y, width: w, height: h, rx: 2, "stroke-width": 1.1 }, svg), t.suave);
      for (const fy of [0.3, 0.7])
        for (const fx of [1 / 6, 3 / 6, 5 / 6]) {
          st(el("circle", { cx: x + w * fx, cy: y + h * fy, r: 11, "stroke-width": 0.9 }, svg), "var(--color-crema)");
          st(el("circle", { cx: x + w * fx, cy: y + h * fy, r: 6.5, "stroke-width": 0.6, opacity: 0.7 }, svg));
        }
    } else {
      st(el("rect", { x, y, width: w, height: h, rx: tipo === "cojin" ? 14 : 2, "stroke-width": 1.1 }, svg), t.suave);
      if (tipo === "cojin") st(el("rect", { x: x + 9, y: y + 9, width: w - 18, height: h - 18, rx: 8, "stroke-width": 0.7, "stroke-dasharray": "3 3", opacity: 0.8 }, svg));
    }
    const g1 = el("g", { "stroke-width": 0.8 }, svg);
    g1.style.stroke = t.trazo;
    el("line", { x1: x, x2: x + w, y1: y - 22, y2: y - 22 }, g1);
    el("line", { x1: x, x2: x, y1: y - 26, y2: y - 18 }, g1);
    el("line", { x1: x + w, x2: x + w, y1: y - 26, y2: y - 18 }, g1);
    const ta = el("text", { x: x + w / 2, y: y - 25 - fs * 0.3, "text-anchor": "middle", "font-size": fs }, svg);
    ta.style.fill = t.texto;
    ta.textContent = medida(cw);
    const g2 = el("g", { "stroke-width": 0.8 }, svg);
    g2.style.stroke = t.trazo;
    el("line", { x1: x + w + 16, x2: x + w + 16, y1: y, y2: y + h }, g2);
    el("line", { x1: x + w + 12, x2: x + w + 20, y1: y, y2: y }, g2);
    el("line", { x1: x + w + 12, x2: x + w + 20, y1: y + h, y2: y + h }, g2);
    const tl = el("text", { x: x + w + 22 + fs * 0.35, y: y + h / 2, "text-anchor": "middle", "font-size": fs, "writing-mode": "vertical-rl" }, svg);
    tl.style.fill = t.texto;
    tl.textContent = medida(ch);
  }

  /* ── Botones de talla (radiogroup) ─────────────────────── */
  /** Marca la talla elegida en un grupo [data-chips]. Las clases de cada estado viven en el HTML. */
  function marcarChips(grupo, k) {
    $$("[data-chip]", grupo).forEach((b) => {
      const on = b.dataset.chip === k;
      b.setAttribute("aria-checked", String(on));
      b.toggleAttribute("data-on", on);
    });
  }

  /* ── Portada: la talla redibuja el plano y el botón ─────── */
  function portada() {
    $$("[data-portada]").forEach((sec) => {
      const grupo = $("[data-chips]", sec);
      const svg = $("svg[data-plano-cama]", sec);
      const boton = $("[data-portada-boton]", sec);
      if (!grupo) return;
      grupo.addEventListener("click", (e) => {
        const b = e.target.closest("[data-chip]");
        if (!b) return;
        const t = tallaDe(b.dataset.chip);
        marcarChips(grupo, b.dataset.chip);
        if (svg && t) planoDe(svg).poner(t);
        if (boton && t) {
          const base = boton.dataset.base;
          boton.href = base + (base.includes("?") ? "&" : "?") + "talla=" + encodeURIComponent(t.clave);
          const txt = $("[data-portada-texto]", boton);
          if (txt) txt.textContent = plantilla(boton.dataset.plantilla, { talla: t.boton });
        }
      });
    });
  }

  /* ── Guía de medidas (modal) ───────────────────────────── */
  const Guia = (() => {
    let modal, alElegir, disparador;
    const abrir = (onPick) => {
      modal = modal || $("[data-guia]");
      if (!modal) return;
      alElegir = onPick || null;
      disparador = document.activeElement;
      modal.hidden = false;
      $("[data-guia-caja]", modal).classList.remove("guia-in");
      void modal.offsetWidth;
      $("[data-guia-caja]", modal).classList.add("guia-in");
      $$("[data-guia-talla]", modal).forEach((b) => {
        b.disabled = !alElegir;
        $("[data-guia-elegir]", b)?.toggleAttribute("hidden", !alElegir);
      });
      $$("svg[data-plano-cama]", modal).forEach((svg) => planoDe(svg).poner(tallaDe(svg.dataset.talla), false));
      bloquear("guia", true);
      $("button", modal)?.focus();
    };
    const cerrar = () => {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      bloquear("guia", false);
      disparador?.focus?.();
    };
    const iniciar = () => {
      modal = $("[data-guia]");
      if (!modal) return;
      modal.addEventListener("click", (e) => {
        if (e.target.closest("[data-guia-cerrar]")) return cerrar();
        const b = e.target.closest("[data-guia-talla]");
        if (b && alElegir) {
          alElegir(b.dataset.guiaTalla);
          cerrar();
        }
      });
      document.addEventListener("keydown", (e) => e.key === "Escape" && cerrar());
      document.addEventListener("click", (e) => {
        const a = e.target.closest("[data-abrir-guia]");
        if (a && !a.closest("[data-ficha]")) {
          e.preventDefault();
          abrir(null);
        }
      });
    };
    return { iniciar, abrir, cerrar };
  })();

  /* ── Ficha de producto ─────────────────────────────────── */
  function ficha() {
    const raizF = $("[data-ficha]");
    if (!raizF) return;
    let D;
    try {
      D = JSON.parse($("[data-ficha-datos]", raizF).textContent);
    } catch (e) {
      return;
    }
    const params = new URLSearchParams(location.search);
    const tallas = D.tallas || [];
    const colores = D.colores || [];
    const conColor = colores.length > 1 || (colores[0] && colores[0].nombre);

    let ci = Math.max(0, colores.findIndex((c) => c.actual));
    const pColor = params.get("color");
    if (pColor) {
      const j = colores.findIndex((c) => clave(c.nombre) === clave(pColor));
      if (j >= 0) ci = j;
    }
    const pVar = params.get("variant");
    if (pVar) {
      const j = colores.findIndex((c) => Object.values(c.variantes).some((v) => String(v.id) === pVar));
      if (j >= 0) ci = j;
    }
    let talla = null;
    const pTalla = clave(params.get("talla"));
    if (pTalla && tallas.some((t) => t.clave === pTalla)) talla = pTalla;
    if (!talla && pVar && tallas.length) {
      const k = Object.entries(colores[ci].variantes).find(([, v]) => String(v.id) === pVar);
      if (k) talla = k[0];
    }
    let cant = 1;
    let vista = 0;

    const r = (s) => $(s, raizF);
    const precio = r("[data-precio]");
    const antes = r("[data-antes]");
    const antesValor = r("[data-antes-valor]");
    const foto = r("[data-foto]");
    const tinte = r("[data-tinte]");
    const miniaturas = r("[data-miniaturas]");
    const leyendaTalla = r("[data-leyenda-talla]");
    const leyendaColor = r("[data-leyenda-color]");
    const nota = r("[data-nota-color]");
    const chips = r("[data-chips]");
    const plano = r("svg[data-plano-cama]");
    const planoAviso = r("[data-plano-aviso]");
    const error = r("[data-error-talla]");
    const cantidad = r("[data-cantidad]");
    const agregar = r("[data-agregar]");
    const textoAgregar = r("[data-agregar-texto]");
    const envio = r("[data-envio]");

    const variante = () => {
      const c = colores[ci];
      if (!c) return null;
      const k = tallas.length ? talla || tallas[0].clave : "unica";
      return c.variantes[k] || Object.values(c.variantes)[0] || null;
    };

    const luminancia = (hex) => {
      const n = parseInt(String(hex).replace("#", ""), 16);
      if (Number.isNaN(n)) return 1;
      const v = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((x) => {
        const c = x / 255;
        return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
      });
      return 0.2126 * v[0] + 0.7152 * v[1] + 0.0722 * v[2];
    };

    /** Tinte digital sobre la foto base mientras llegan las fotos de cada tono. */
    const aplicarTinte = (capa, hex) => {
      if (!capa) return;
      const tono = D.tenir && hex && luminancia(hex) < 0.82 ? hex : null;
      capa.hidden = !tono;
      if (!tono) return;
      const oscuro = Math.min(0.92, 1 - luminancia(tono));
      const [a, b] = capa.children;
      a.style.background = tono;
      b.style.background = tono;
      b.style.opacity = String(oscuro * 0.85);
    };

    const ponerFoto = () => {
      const c = colores[ci];
      const f = c && c.fotos[vista];
      if (!f || !foto) return;
      if (foto.getAttribute("src") !== f.src) {
        foto.srcset = f.srcset;
        foto.src = f.src;
      }
      foto.alt = c.nombre ? `${$("h1", raizF).textContent.trim()}, ${D.etiquetaColor.toLowerCase()} ${c.nombre}` : f.alt;
      aplicarTinte(tinte, vista === 0 ? c.hex : null);
      $$("[data-vista]", miniaturas || raizF).forEach((b) => {
        const on = Number(b.dataset.vista) === vista;
        b.setAttribute("aria-pressed", String(on));
        b.toggleAttribute("data-on", on);
      });
    };

    const ponerMiniaturas = () => {
      if (!miniaturas) return;
      const c = colores[ci];
      const fotos = (c && c.fotos) || [];
      miniaturas.hidden = fotos.length < 2;
      miniaturas.innerHTML = fotos
        .map(
          (f, i) => `<li><button type="button" data-vista="${i}" aria-label="Foto ${i + 1}" aria-pressed="false" class="relative block aspect-square w-full overflow-hidden rounded-[10px] border-2 border-crema-3 bg-crema-2 transition-colors hover:border-tinta/40 data-[on]:border-tinta"><img src="${f.chica}" alt="" loading="lazy" class="absolute inset-0 h-full w-full object-cover">${
            i === 0 && D.tenir ? '<span data-tinte-mini class="absolute inset-0" hidden><span class="absolute inset-0" style="mix-blend-mode:color"></span><span class="absolute inset-0" style="mix-blend-mode:multiply"></span></span>' : ""
          }</button></li>`,
        )
        .join("");
      aplicarTinte($("[data-tinte-mini]", miniaturas), c && c.hex);
    };

    const pintar = () => {
      const c = colores[ci];
      const v = variante();
      if (v) {
        precio.textContent = pesos(v.precio);
        const hay = v.antes > v.precio;
        if (antes) antes.hidden = !hay;
        if (antesValor && hay) antesValor.textContent = pesos(v.antes);
      }
      if (leyendaTalla) {
        const t = tallas.find((x) => x.clave === talla);
        const tt = t && tallaDe(t.clave);
        leyendaTalla.textContent = t ? `: ${t.nombre}${tt && tt.ancho ? `, ${tt.ancho}×${tt.largo} cm` : ""}` : "";
      }
      if (chips) marcarChips(chips, talla || "__");
      if (plano) {
        const t = tallaDe(talla) || tallaDe("doble") || TALLAS[0];
        planoDe(plano).poner(t);
        plano.classList.toggle("opacity-50", !talla);
        if (planoAviso) planoAviso.hidden = Boolean(talla);
      }
      if (leyendaColor && c) leyendaColor.textContent = c.nombre ? `: ${c.nombre}` : "";
      $$("[data-color]", raizF).forEach((b) => {
        const on = Number(b.dataset.color) === ci;
        b.setAttribute("aria-checked", String(on));
        b.toggleAttribute("data-on", on);
      });
      if (nota) {
        nota.textContent = c && c.nota ? `${c.nota}.` : "";
        nota.hidden = !(c && c.nota);
      }
      if (cantidad) cantidad.textContent = cant;
      if (envio && F.envioGratis > 0 && v) {
        const gratis = v.precio * cant >= F.envioGratis;
        envio.innerHTML = gratis ? `<span class="text-tinta">${T.envioGratisAqui}</span>` : plantilla(T.envioGratisDesde, { monto: pesos(F.envioGratis) });
      }
      if (agregar && v) {
        agregar.disabled = !v.disponible;
        if (!agregar.hasAttribute("data-hecho")) textoAgregar.textContent = v.disponible ? T.agregar : T.agotado;
      }
    };

    const url = () => {
      const c = colores[ci];
      const p = new URLSearchParams(location.search);
      p.delete("variant");
      if (talla) p.set("talla", talla);
      else p.delete("talla");
      const grupo = colores.length > 1 && colores.some((x) => x.producto !== colores[0].producto);
      let ruta = location.pathname;
      if (grupo && c.url) {
        ruta = c.url;
        p.delete("color");
      } else if (conColor && ci !== 0) p.set("color", c.nombre);
      else p.delete("color");
      const qs = p.toString();
      const nueva = ruta + (qs ? "?" + qs : "");
      if (nueva !== location.pathname + location.search) history.replaceState(history.state, "", nueva);
    };

    raizF.addEventListener("click", async (e) => {
      const chip = e.target.closest("[data-chip]");
      if (chip && chips && chips.contains(chip)) {
        talla = chip.dataset.chip;
        if (error) error.hidden = true;
        pintar();
        url();
        return;
      }
      const col = e.target.closest("[data-color]");
      if (col) {
        ci = Number(col.dataset.color);
        vista = 0;
        ponerMiniaturas();
        ponerFoto();
        pintar();
        url();
        return;
      }
      const vb = e.target.closest("[data-vista]");
      if (vb) {
        vista = Number(vb.dataset.vista);
        ponerFoto();
        return;
      }
      if (e.target.closest("[data-menos]")) {
        cant = Math.max(1, cant - 1);
        pintar();
        return;
      }
      if (e.target.closest("[data-mas]")) {
        cant += 1;
        pintar();
        return;
      }
      if (e.target.closest("[data-abrir-guia]")) {
        e.preventDefault();
        Guia.abrir(tallas.length ? (k) => {
          if (tallas.some((t) => t.clave === k)) {
            talla = k;
            if (error) error.hidden = true;
            pintar();
            url();
          }
        } : null);
        return;
      }
      if (e.target.closest("[data-agregar]")) {
        if (tallas.length && !talla) {
          if (error) {
            error.textContent = T.eligeTalla;
            error.hidden = false;
          }
          r("#talla")?.scrollIntoView({ block: "center", behavior: reduce() ? "auto" : "smooth" });
          return;
        }
        const v = variante();
        if (!v || !v.disponible) return;
        agregar.disabled = true;
        try {
          await Carrito.agregar(v.id, cant);
          agregar.setAttribute("data-hecho", "");
          textoAgregar.textContent = T.agregado;
          $("[data-agregar-check]", agregar)?.removeAttribute("hidden");
          Carrito.abrir();
          setTimeout(() => {
            agregar.removeAttribute("data-hecho");
            $("[data-agregar-check]", agregar)?.setAttribute("hidden", "");
            pintar();
          }, 1800);
        } catch (err) {
          if (error) {
            error.textContent = err.message || T.errorCarrito;
            error.hidden = false;
          }
        } finally {
          agregar.disabled = false;
          pintar();
        }
      }
    });

    // El visto bueno de cada color se pinta en tinta sobre los tonos claros.
    $$("[data-color]", raizF).forEach((b) => {
      const chk = $("[data-check]", b);
      if (chk && b.dataset.hex && luminancia(b.dataset.hex) >= 0.82) chk.classList.replace("text-crema", "text-tinta");
    });
    // Estado inicial (color de la URL o del producto abierto): galería y miniaturas de ese color.
    ponerMiniaturas();
    if (foto) foto.hidden = false;
    ponerFoto();
    pintar();
  }

  /* ── Catálogo con filtros en la URL ────────────────────── */
  function catalogo() {
    const cat = $("[data-catalogo]");
    if (!cat) return;
    const items = $$("[data-item]", cat);
    const titulo = $("[data-catalogo-titulo]", cat);
    const tituloBase = titulo ? titulo.textContent : "";
    const conteo = $("[data-conteo]", cat);
    const vacio = $("[data-vacio]", cat);
    const lista = $("[data-lista]", cat);
    const limpiar = $("[data-limpiar]", cat);
    const selCol = $("[data-filtro-coleccion]", cat);
    const selTalla = $("[data-filtro-talla]", cat);
    const coloresBox = $("[data-filtro-colores]", cat);

    // Los colores del filtro salen de las tarjetas: todos, sin repetir, en el orden de Ajustes.
    if (coloresBox) {
      const tonos = {};
      String(F.colores || "")
        .split(/\r?\n/)
        .forEach((l, i) => {
          const p = l.split("|").map((x) => x.trim());
          if (p[0]) tonos[clave(p[0])] = { hex: p[1], orden: i };
        });
      const vistos = new Map();
      items.forEach((it) =>
        (it.querySelector("[data-tarjeta]").dataset.colores || "")
          .split("|")
          .filter(Boolean)
          .forEach((c) => !vistos.has(clave(c)) && vistos.set(clave(c), c)),
      );
      const muestras = {};
      $$("[data-muestra-color]", cat).forEach((m) => (muestras[m.dataset.muestraColor] = m.dataset.src));
      const orden = [...vistos.entries()].sort((a, b) => (tonos[a[0]]?.orden ?? 999) - (tonos[b[0]]?.orden ?? 999));
      coloresBox.innerHTML = orden
        .map(
          ([k, nombre]) =>
            `<button type="button" data-filtro="color" data-valor="${nombre.replace(/"/g, "&quot;")}" aria-pressed="false" aria-label="${nombre}" title="${nombre}" class="btn-press flex h-8 w-8 items-center justify-center rounded-full border border-transparent transition-[border-color,transform] hover:border-tinta/40 aria-pressed:scale-110 aria-pressed:border-tinta"><span class="relative block h-5 w-5 overflow-hidden rounded-full border border-tinta/15" style="background:${tonos[k]?.hex || "#d9d6c4"}">${
              muestras[k] ? `<img src="${muestras[k]}" alt="" class="absolute inset-0 h-full w-full object-cover">` : ""
            }</span></button>`,
        )
        .join("");
    }

    const leer = () => {
      const p = new URLSearchParams(location.search);
      return { categoria: p.get("categoria"), coleccion: p.get("coleccion"), talla: p.get("talla"), color: p.get("color") };
    };
    const escribir = (f) => {
      const p = new URLSearchParams(location.search);
      for (const k of ["categoria", "coleccion", "talla", "color"]) {
        if (f[k]) p.set(k, f[k]);
        else p.delete(k);
      }
      const qs = p.toString();
      history.replaceState(history.state, "", location.pathname + (qs ? "?" + qs : ""));
    };

    const aplicar = () => {
      const f = leer();
      let n = 0;
      items.forEach((it) => {
        const t = it.querySelector("[data-tarjeta]");
        const cols = (t.dataset.cols || "").split(" ");
        const ts = (t.dataset.tallas || "").split(",");
        const cs = (t.dataset.colores || "").split("|").map(clave);
        const ok =
          (!f.categoria || cols.includes(f.categoria)) &&
          (!f.coleccion || cols.includes(f.coleccion)) &&
          (!f.talla || ts.includes(f.talla)) &&
          (!f.color || cs.includes(clave(f.color)));
        it.hidden = !ok;
        if (ok) n++;
      });
      $$("[data-filtro]", cat).forEach((b) => {
        const k = b.dataset.filtro;
        const on = k === "color" ? clave(f.color) === clave(b.dataset.valor) && Boolean(f.color) : f[k] === b.dataset.valor;
        b.setAttribute("aria-pressed", String(on));
      });
      if (selCol) selCol.value = f.coleccion || "";
      if (selTalla) selTalla.value = f.talla || "";
      if (titulo) {
        const bCat = f.categoria && $(`[data-filtro="categoria"][data-valor="${CSS.escape(f.categoria)}"]`, cat);
        const oCol = f.coleccion && selCol && $(`option[value="${CSS.escape(f.coleccion)}"]`, selCol);
        titulo.textContent = bCat ? bCat.dataset.titulo : oCol ? oCol.textContent : tituloBase;
      }
      if (conteo) conteo.textContent = `${n} ${n === 1 ? T.producto : T.productos}`;
      if (vacio) vacio.hidden = n > 0;
      if (lista) lista.hidden = n === 0;
      if (limpiar) limpiar.hidden = !Object.values(f).some(Boolean);
    };

    cat.addEventListener("click", (e) => {
      const b = e.target.closest("[data-filtro]");
      if (b) {
        const f = leer();
        const k = b.dataset.filtro;
        const v = b.dataset.valor;
        f[k] = (k === "color" ? clave(f[k]) === clave(v) : f[k] === v) ? null : v;
        escribir(f);
        aplicar();
        return;
      }
      if (e.target.closest("[data-limpiar]")) {
        escribir({});
        aplicar();
      }
    });
    selCol?.addEventListener("change", () => {
      const f = leer();
      f.coleccion = selCol.value || null;
      escribir(f);
      aplicar();
    });
    selTalla?.addEventListener("change", () => {
      const f = leer();
      f.talla = selTalla.value || null;
      escribir(f);
      aplicar();
    });
    window.addEventListener("popstate", aplicar);
    aplicar();
  }

  /* ── Sala navideña: el estampado viste la sala ─────────── */
  function salas() {
    $$("[data-sala]").forEach((sala) => {
      const fotos = $$("[data-sala-foto]", sala);
      const botones = $$("[data-estampado]", sala);
      const nombre = $("[data-sala-nombre]", sala);
      const nota = $("[data-sala-nota]", sala);
      const piezas = $$("[data-pieza]", sala);
      const elegir = (i) => {
        const b = botones[i];
        botones.forEach((x, j) => {
          x.setAttribute("aria-checked", String(j === i));
          x.toggleAttribute("data-on", j === i);
        });
        fotos.forEach((f, j) => {
          const on = j === i;
          f.toggleAttribute("data-on", on);
          f.setAttribute("aria-hidden", String(!on));
          const img = $("img", f);
          if (on && img && img.loading === "lazy") img.loading = "eager";
        });
        if (nombre) nombre.textContent = b.dataset.nombre;
        if (nota) {
          nota.textContent = b.dataset.nota ? `${b.dataset.nota}.` : "";
          nota.hidden = !b.dataset.nota;
        }
        piezas.forEach((a) => {
          const u = new URL(a.dataset.base, location.origin);
          u.searchParams.set("color", b.dataset.nombre);
          a.href = u.pathname + u.search;
        });
      };
      botones.forEach((b, i) => b.addEventListener("click", () => elegir(i)));
    });
  }

  /* ── Videos: se bajan cuando la sección se acerca ──────── */
  function videos() {
    const cajas = $$("[data-video]");
    if (!cajas.length || reduce()) return;
    const movil = matchMedia("(max-width: 767px)").matches;
    const cargar = (caja) => {
      if (caja.dataset.cargado) return;
      caja.dataset.cargado = "1";
      const v = document.createElement("video");
      const src = (movil && caja.dataset.videoMovil) || caja.dataset.video;
      Object.assign(v, { src, autoplay: true, muted: true, loop: true, playsInline: true });
      v.setAttribute("aria-hidden", "true");
      v.setAttribute("playsinline", "");
      v.className = "absolute inset-0 h-full w-full object-cover";
      caja.appendChild(v);
      v.play?.().catch(() => {});
    };
    if (!("IntersectionObserver" in window)) return cajas.forEach(cargar);
    const io = new IntersectionObserver(
      (es) =>
        es.forEach((e) => {
          if (e.isIntersecting) {
            cargar(e.target);
            io.unobserve(e.target);
          }
        }),
      { rootMargin: "400px 0px" },
    );
    cajas.forEach((c) => io.observe(c));
  }

  /* ── Arranque ──────────────────────────────────────────── */
  const iniciar = () => {
    cabecera();
    Carrito.iniciar();
    Guia.iniciar();
    planosCama();
    $$("svg[data-plano-pieza]").forEach(planoPieza);
    portada();
    ficha();
    catalogo();
    salas();
    videos();
    apariciones();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();
})();
